module.exports = __webpack_public_path__ + "img/76354.3e949483.svg";